<template>
    <div class="radio-select" :data-val="value">
        <div class="top">
            <span class="required" v-if="required">*</span>
            <div class="title" v-html="title"></div>
        </div>

        <template v-for="item in options">
            <template v-if="isDetails">
                <SelectOption :data-is-verdict="item.isVerdict" @click.native="selectOption(item.val)" class="option" :desc="item.desc" :key="item.val" :active="value.indexOf(item.val) != -1" v-if="isDetails && value.indexOf(item.val) != -1"></SelectOption>
            </template>
            <template v-else>
                <SelectOption :data-is-verdict="item.isVerdict" @click.native="selectOption(item.val)" class="option" :desc="item.desc" :key="item.val" :active="value.indexOf(item.val) != -1"></SelectOption>
            </template>
            <div class="child" v-if="item.child && value.indexOf(item.val) != -1">
                <div class="yes" v-if="item.child.name == 'MultiSelectAndInput' || item.child.name == 'RadioSelectAndInput' || item.child.name == 'InputOption'">
                    <component :isDetails="isDetails" :is='item.child.name'  v-bind="item.child.props" v-model="item.child.value"></component>
                </div>
                <div v-else class="no">目前只支持MultiSelectAndInput、RadioSelectAndInput、InputOption</div>
            </div>
        </template>

    </div>
</template>
<script>
    import SelectOption from './Private/SelectOption.vue'
    import InputOption from './Private/InputOption.vue'
    import MultiSelectAndInput from './MultiSelectAndInput.vue'
    import RadioSelectAndInput from './RadioSelectAndInput.vue'
    export default {
        name: 'MultiSelect',
        props: {
            value:Array,
            title:String,
            required:Boolean,
            options: {
                type: Array,
                default:function () {
                    return []
                }
            },
            isDetails:{
                type:Boolean,
                default:false
            }
        },
        methods:{
            selectOption(val){
                if(this.isDetails){return;}
                let index = this.value.indexOf(val);
                if(index == -1){
                    this.$emit('input',[...this.value,val].sort());
                }else {
                    let val = [...this.value];
                    val.splice(index,1);
                    this.$emit('input',val.sort());
                }
            }
        },
        components:{SelectOption,RadioSelectAndInput,MultiSelectAndInput,InputOption}
    }
</script>
<style lang="scss" scoped>
    .radio-select{
        padding: 16px;
        .top{
            display: flex;
            align-items: center;
            .required{
                color: #F84025;
                margin-right: 6px;
            }
            .title{
                color: #26292F;
                font-size: 16px;
            }
        }
        .option{
            margin-top: 16px;
        }
    }

</style>
